import * as React from "react";
import moment from "moment";
import { useState, useEffect } from "react";
import WorklogChat from "../../components/WorklogChat";
import DatatableComponent from "helpers/DatatableComponent";
const WorklogReportRendering = ({ list, setList, url, title, type }) => {
    const [worklog, setWorklog] = useState(null);

    // Helper function to calculate total time
    const calculateTotalTime = () => {
        let totalMinutes = 0;

        list.forEach(item => {
            const duration = item?.duration;
            if (!duration) return;

            // Handle new format like "3h:0m"
            if (typeof duration === 'string' && duration.includes('h') && duration.includes('m')) {
                const parts = duration.replace('h', '').replace('m', '').split(':');
                const hours = parseInt(parts[0]) || 0;
                const minutes = parseInt(parts[1]) || 0;
                totalMinutes += (hours * 60) + minutes;
                return;
            }

            // Handle legacy format (numeric string representing hours)
            if (typeof duration === 'string' && !isNaN(duration)) {
                const hours = parseInt(duration);
                totalMinutes += hours * 60;
                return;
            }

            // Handle numeric values (assuming minutes)
            if (typeof duration === 'number') {
                totalMinutes += duration;
                return;
            }
        });

        // Convert total minutes back to readable format
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        if (hours >= 24) {
            const days = Math.floor(hours / 24);
            const remainingHours = hours % 24;
            return `${days}d ${remainingHours}h ${minutes}m`;
        }
        return `${hours}h ${minutes}m`;
    };

    const calculateTotalEntries = () => {
        const seenDates = new Set();
        list.forEach(item => {
            if (!item?.startDate) return;
            const dateOnly = moment(item.startDate).format('YYYYMMDD');
            seenDates.add(dateOnly);
        });
        return seenDates.size;
    };

    const columns = [
        {
            name: "description",
            label: "Work",
            options: {
                filter: true,
                sort: true,
                setCellHeaderProps: () => ({
                    style: { maxWidth: '1400px', width: '1400px' }
                }),
                setCellProps: () => ({
                    style: { maxWidth: '1400px', width: '1400px', wordWrap: 'break-word' }
                }),
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const item = list[rowIndex];
                    // Check if this is the total row
                    if (!item) {
                        return (
                            <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                TOTAL
                            </div>
                        );
                    }

                    const projectName = item?.project?.name || item?.task?.name || item?.activity?.name || '';
                    const description = item?.description || '';
                    let displayType = '';

                    if (type === 'all') {
                        if (item?.project?.name) {
                            displayType = 'Project';
                        } else if (item?.task?.name) {
                            displayType = 'Task';
                        } 
                    } else {
                        displayType = type.charAt(0).toUpperCase() + type.slice(1);
                    }

                    return (
                        <div style={{ maxWidth: '1400px', wordWrap: 'break-word', overflow: 'hidden' }}>
                            {projectName && displayType && <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{displayType} Name: {projectName}</div>}
                            <div dangerouslySetInnerHTML={{ __html: description }} />
                        </div>
                    );
                },
            },
        },
        {
            name: "startDate",
            label: "Date",
            options: {
                filter: true,
                sort: true,
                // customBodyRender: (value) => moment(value).isValid() ? moment(value).format("DD/MM/yyyy") : "",
                customBodyRenderLite: (id, index) => {
                    const item = list[index];
                    if (!item) {
                        return (
                            <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {/* {calculateTotalEntries()} Entries */}
                                {calculateTotalEntries()} Days
                            </div>
                        );
                    };

                    const startDate = item?.startDate;
                    return moment(startDate).isValid() ? moment(startDate).format("DD/MM/yyyy") : "";

                }
            },
        },
        {
            name: "duration",
            label: "Time Spent",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const item = list[rowIndex];
                    if (!item) {
                        return (
                            <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {calculateTotalTime()}
                            </div>
                        );
                    }

                    const duration = item?.duration;

                    if (!duration) return "0h 0m";

                    if (typeof duration === 'string' && duration.includes('h') && duration.includes('m')) {
                        return duration.replace(':', ' ');
                    }

                    // Handle legacy format (numeric string representing hours)
                    if (typeof duration === 'string' && !isNaN(duration)) {
                        const hours = parseInt(duration);
                        if (hours >= 24) {
                            const days = Math.floor(hours / 24);
                            const remainingHours = hours % 24;
                            return `${days}d ${remainingHours}h`;
                        }
                        return `${hours}h 0m`;
                    }
                    if (typeof duration === 'number') {
                        const hours = Math.floor(duration / 60);
                        const minutes = duration % 60;
                        if (hours >= 24) {
                            const days = Math.floor(hours / 24);
                            const remainingHours = hours % 24;
                            return `${days}d ${remainingHours}h ${minutes}m`;
                        }
                        return `${hours}h ${minutes}m`;
                    }

                    return duration.toString();
                }
            }
        },
        {
            name: "endDate",
            label: "Assignee",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (id, index) => {
                    return list[index]?.resource?.names
                }
            }
            ,
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (id, index) => {
                    // if (type === "task") {
                    //     return list[index]?.task?.status;
                    // }
                    // else if (type === "project") {
                    //     return list[index]?.project?.status;
                    // }
                    // return "";
                    return list[index]?.task?.status || list[index]?.project?.status || list[index]?.activity?.status ||"";
                }
            }
        }
    ];
    return <div>
        {worklog !== null && <WorklogChat worklog={worklog} open={true} onClose={() => setWorklog(null)} />}
        <DatatableComponent
            pdf={true}
            excel={true}
            viewColumns={false}
            searchfield={true}
            search={false}
            fileName={'Worklog report'}
            processData={(data) => {
                const originalData = data.data || [];
                setList(originalData);



                // Add total row if there's data
                if (originalData.length > 0) {
                    const totalRow = {
                        description: "TOTAL",
                        startDate: "",
                        duration: calculateTotalTime(),
                        endDate: "",
                        status: "",
                        isTotal: true // Flag to identify this as the total row
                    };

                    return {
                        ...data,
                        data: [...originalData, totalRow]
                    };
                }

                return data;
            }} elevation={1} columns={columns} url={url} title={title ?? 'Worklog List'} />
    </div>
}

export default WorklogReportRendering;